import _ from 'lodash';

import {
  Id,
  Practice,
  PracticeEnablementConfig,
  PracticePreference,
  PreferenceValue,
} from 'ev-types';

import { useCurrentPractice } from 'ev-hooks/commonData';

export function getPracticePreference(
  practice: Practice | undefined,
  preference: PracticePreference,
) {
  if (!practice) {
    return false;
  }
  const pref = _.find(practice.attributes.preferences, {
    name: preference,
  });

  return pref && pref.value;
}

export const getPracticePreferences = (
  practice: Practice | undefined,
  preferences: PracticePreference[],
) =>
  preferences.reduce((acc, preference) => {
    const pref = practice?.attributes.preferences.find(
      ({ name }) => name === preference,
    );
    acc.set(preference, pref?.value);
    return acc;
  }, new Map<PracticePreference, PreferenceValue>());

export function getPracticeEnablementConfig(
  practice: Practice | undefined,
  config: PracticeEnablementConfig,
) {
  return practice?.attributes.enablement_configs[config] ?? false;
}

export const useGetProviderGroup = (providerGroupId: Id | null) => {
  const { attributes } = useCurrentPractice();
  if (providerGroupId === null) {
    return undefined;
  }
  return attributes.provider_groups.find(({ id }) => id === providerGroupId);
};
